module.exports = __webpack_public_path__ + "static/media/talkmore-icons.5c0ae6e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/talkmore-icons.svg
// module id = 121
// module chunks = 0